import { FaSpinner } from "react-icons/fa";
import ModalLayout from "../layouts/ModalLayout";

interface DeleteConfirmationModalProps {
  title: string;
  message: string;
  onDelete: () => void;
  onCancel: () => void;
  loading: boolean
}

function DeleteConfirmationModal({ title, message, onDelete, onCancel, loading }: DeleteConfirmationModalProps) {

  return (
    <ModalLayout>
      <div>
      <div className="flex flex-col items-center mb-10">
        <h3 className="font-semibold text-[22px] mb-2">{title}</h3>
        <p className="text-center text-[--grey-muted] pb-2">{message}</p>
      </div>
      <div className="flex flex-row mt-4 justify-center gap-4">
        <button
          disabled={loading}
          type="button"
          className="btn btn-aqua px-9 py-3 bg-red-400"
          onClick={onDelete}>
          Delete

          {loading && (
            <FaSpinner className="ml-2 inline animate-spin" />
          )}
        </button>
        <button
          type="button"
          className="btn btn-outline px-9 py-3"
          onClick={onCancel}>
          Cancel
        </button>
      </div>
    </div>
    </ModalLayout>
    

  );
}

export default DeleteConfirmationModal